<template>
	<view class="box">
		<!-- 顶部固定栏 -->
		<div class="Fixed">
			<div class="Fixed_left">
				<span class="Fixed_left_txt">体检报告</span>
			</div>
			<div class="Fixed_right">
				<div class="Fixed_right_sty">
					<img class="Fixed_right_img" src="../../static/xiazai.png" alt="">
					<span class="Fixed_right_txt">下载</span>
				</div>
				<div class="Fixed_right_sty">
					<img class="Fixed_right_img" src="../../static/gengduo.png" alt="">
					<span class="Fixed_right_txt">更多</span>
				</div>
			</div>
		</div>

		<!-- 基本健康数据 -->
		<div class="data">
			<div class="data_left">
				<img class="data_img" src="../../static/4.png" alt="">
				<div class="data_left_sty1">
					<span class="data_left_txt1">xxx</span>
					<div class="data_left_sty">
						<span class="data_left_txt2">2022-04-08</span>
					</div>
				</div>
			</div>
			<div class="data_right">
				<span class="data_right_txt1">基本健康数据</span>
				<div class="data_right_sty">
					<span class="data_right_txt2">身高(cm)</span>
					<span class="data_right_txt3">161.0</span>
				</div>
				<div class="data_right_sty">
					<span class="data_right_txt2">体重(kg)</span>
					<span class="data_right_txt3">74.7</span>
				</div>
				<div class="data_right_sty">
					<span class="data_right_txt4">体重指数</span>
					<span class="data_right_txt5">28.8</span>
				</div>
				<div class="data_right_sty">
					<span class="data_right_txt2">收缩压</span>
					<span class="data_right_txt3">161.0</span>
				</div>
				<div class="data_right_sty">
					<span class="data_right_txt2">身高(cm)</span>
					<span class="data_right_txt3">119</span>
				</div>
				<div class="data_right_sty">
					<span class="data_right_txt4">总胆固醇</span>
					<span class="data_right_txt5">5.22</span>
				</div>
				<div class="data_right_sty">
					<span class="data_right_txt2">尿酸</span>
					<span class="data_right_txt3">363</span>
				</div>
				<div class="data_right_sty">
					<span class="data_right_txt2">血红蛋白</span>
					<span class="data_right_txt3">151.0</span>
				</div>
			</div>
		</div>

		<!-- 总检建议 -->
		<div class="bottom">
			<uni-collapse class="bottom_sty">
				<uni-collapse-item title="总检建议" thumb="/static/yisheng.png">
					<view class="content">
						<text class="text">折叠内容主体，可自定义内容及样式</text>
					</view>
				</uni-collapse-item>
			</uni-collapse>
			<uni-collapse class="bottom_sty">
				<uni-collapse-item title="异常结果汇总">
					<view class="content">
						<text class="text">折叠内容主体，可自定义内容及样式</text>
					</view>
				</uni-collapse-item>
			</uni-collapse>
			<uni-collapse class="bottom_sty">
				<uni-collapse-item title="加项检查结果">
					<view class="content">
						<text class="text">折叠内容主体，可自定义内容及样式</text>
					</view>
				</uni-collapse-item>
			</uni-collapse>
			<div class="bottom_sty">
				<view class="content">
					<text class="text">健康检查结果</text>
				</view>
			</div>
			<uni-collapse class="bottom_sty">
				<uni-collapse-item title="一般项目检查" thumb="/static/yaoxiang.png">
					<view class="content">
						<text class="text">折叠内容主体，可自定义内容及样式</text>
					</view>
				</uni-collapse-item>
			</uni-collapse>
			<uni-collapse class="bottom_sty">
				<uni-collapse-item title="内科" thumb="/static/neike.png">
					<view class="content">
						<text class="text">折叠内容主体，可自定义内容及样式</text>
					</view>
				</uni-collapse-item>
			</uni-collapse>
			<uni-collapse class="bottom_sty">
				<uni-collapse-item title="耳鼻咽喉科" thumb="/static/erduo.png">
					<view class="content">
						<text class="text">折叠内容主体，可自定义内容及样式</text>
					</view>
				</uni-collapse-item>
			</uni-collapse>
			<uni-collapse class="bottom_sty">
				<uni-collapse-item title="口腔科" thumb="/static/ya.png">
					<view class="content">
						<text class="text">折叠内容主体，可自定义内容及样式</text>
					</view>
				</uni-collapse-item>
			</uni-collapse>
			<uni-collapse class="bottom_sty">
				<uni-collapse-item title="血常规(五分类)" thumb="/static/baogao.png">
					<view class="content">
						<text class="text">折叠内容主体，可自定义内容及样式</text>
					</view>
				</uni-collapse-item>
			</uni-collapse>
			<uni-collapse class="bottom_sty">
				<uni-collapse-item title="尿常规" thumb="/static/niao.png">
					<view class="content">
						<text class="text">折叠内容主体，可自定义内容及样式</text>
					</view>
				</uni-collapse-item>
			</uni-collapse>
			<uni-collapse class="bottom_sty">
				<uni-collapse-item title="实验室检查" thumb="/static/shiyanshi.png">
					<view class="content">
						<text class="text">折叠内容主体，可自定义内容及样式</text>
					</view>
				</uni-collapse-item>
			</uni-collapse>
			<uni-collapse class="bottom_sty">
				<uni-collapse-item title="超声室检查" thumb="/static/chaosheng.png">
					<view class="content">
						<text class="text">折叠内容主体，可自定义内容及样式</text>
					</view>
				</uni-collapse-item>
			</uni-collapse>
			<uni-collapse class="bottom_sty">
				<uni-collapse-item title="放射科" thumb="/static/ren.png">
					<view class="content">
						<text class="text">折叠内容主体，可自定义内容及样式</text>
					</view>
				</uni-collapse-item>
			</uni-collapse>
			<uni-collapse class="bottom_sty">
				<uni-collapse-item title="心电图室" thumb="/static/xin.png">
					<view class="content">
						<text class="text">折叠内容主体，可自定义内容及样式</text>
					</view>
				</uni-collapse-item>
			</uni-collapse>
			<uni-collapse class="bottom_sty">
				<uni-collapse-item title="餐厅" thumb="/static/baogao.png">
					<view class="content">
						<text class="text">折叠内容主体，可自定义内容及样式</text>
					</view>
				</uni-collapse-item>
			</uni-collapse>
			<uni-collapse class="bottom_sty">
				<uni-collapse-item title="其他" thumb="/static/baogao.png">
					<view class="content">
						<text class="text">折叠内容主体，可自定义内容及样式</text>
					</view>
				</uni-collapse-item>
			</uni-collapse>
			<div class="bottom_sty">
				<view class="content">
					<span class="text1">报告阅读说明</span>
					<div>
						<span
							class="text2">1.以上报告结果，仅针对本次检查、检验样本负责。本报告不能用于二次会诊、用药、或其他任何医学判断目的的使用。如您有不适症状，或需要医疗服务，请及时到医院就医并遵医嘱。</span>
						<span class="text3">查看更多</span>
						<img class="img" src="/static/youjiantou1.png" alt="">
					</div>
					<div>
						<span class="text2">2.如需了解更多关于检测方法和检测结果参考值得信息，</span>
						<span class="text3">请点这里</span>
						<img class="img" src="/static/youjiantou1.png" alt="">
					</div>
				</view>
			</div>
		</div>

		</div>


	</view>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				value: ['0'],
				accordionVal: '1',
				content: '',
				extraIcon: {
					color: '#4cd964',
					size: '26',
					type: 'image'
				},
			}
		},
		methods: {
			add() {
				if (this.content.length > 35) {
					this.content = ''
				} else {
					this.content = ''
				}
				// TODO 小程序中不支持自动更新 ，需要手动resize 更新组件高度
				// #ifdef MP
				this.$nextTick(() => {
					this.$refs.collapse.resize()
				})
				// #endif
			},
			onClick(e) {
				uni.showToast({
					title: '列表被点击'
				})
			},
			change(e) {
				console.log(e);
			}
		}
	}
</script>

<style lang="scss">
	.box {
		width: 100%;
		height: 850rpx;
		background: linear-gradient(180deg, #fd8b4d 50%, #fdb753, );
	}

	.Fixed {
		width: 100%;
		height: 80rpx;
		background-color: #fd8b4d;
		display: flex;
		justify-content: center;
		align-items: center;
		justify-content: space-between;
		position: fixed;
		left: 20;
		right: 20;
		bottom: 20;
	}

	.Fixed_left_txt {
		margin-left: 286rpx;
		color: #fff;
		font-size: 16px;
		font-weight: 400;
	}

	.Fixed_right {
		display: flex;
	}

	.Fixed_right_sty {
		display: flex;
		flex-direction: column;
		margin-right: 20px;
	}

	.Fixed_right_img {
		width: 45rpx;
		height: 45rpx;
	}

	.Fixed_right_txt {
		color: #fff;
		font-size: 12px;
	}

	.data {
		display: flex;
		justify-content: space-around;
		padding-top: 102rpx;
		margin-bottom: 40rpx;
	}

	.data_left {
		width: 316rpx;
		height: 700rpx;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.data_img {
		width: 316rpx;
		height: 600rpx;
	}

	.data_left_sty1 {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.data_left_txt1 {
		font-size: 20px;
		color: #fff;
	}

	.data_left_sty {
		width: 180rpx;
		height: 50rpx;
		background-color: #f99235;
		border-radius: 20px 20px 20px 20px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.data_left_txt2 {
		font-size: 14px;
		color: #fff;
	}

	.data_right {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-around;
		width: 316rpx;
		height: 700rpx;
		background-color: #fff;
		border-radius: 20px 20px 20px 20px;
	}

	.data_right_txt1 {
		font-size: 18px;
	}

	.data_right_sty {
		width: 316rpx;
		display: flex;
		justify-content: space-around;
	}

	.data_right_txt2 {
		font-size: 14px;
	}

	.data_right_txt3 {
		font-weight: 600;
	}

	.data_right_txt4 {
		color: #f23f45;
		font-size: 14px;
	}

	.data_right_txt5 {
		color: #f23f45;
		font-weight: 600;
	}

	.bottom {
		height: 800px;
		background-color: #ffffff;
	}

	.example-body {
		flex-direction: column;
		flex: 1;
	}

	.content {
		padding: 15px;
	}

	.text1 {
		font-size: 14px;
		font-weight: 600;
	}

	.text2 {
		font-size: 12px;
		color: #8a8a8a;
	}

	.text3 {
		font-size: 12px;
		color: #1d6ebf;
	}

	.img {
		width: 10px;
		height: 10px;
	}
</style>
